<script setup lang="ts">
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";

import BaseDialog from "@/components/ui/dialog/base-dialog.vue";

interface IProps {
  title: string;
  subtitle?: string;
  infos?: string | boolean;
}

const props = defineProps<IProps>();

const isInfosDialogVisible = defineModel<boolean>("infosVisible", {
  required: false,
  default: false,
});
</script>

<template>
  <div
    v-bind="$attrs"
    class="bg-white rounded-md p-6 flex flex-col"
  >
    <div class="flex items-center pb-6 justify-between">
      <div class="flex gap-2">
        <slot name="title-icon">
          <div class="bg-gray-100 rounded-full !w-[20px] !h-[20px] flex justify-center items-center">
            <i class="pi pi-chart" />
          </div>
        </slot>
        <div class="flex flex-col gap-1">
          <h6 class="text-text-secondary font-semibold flex items-center gap-2">
            {{ props.title }}
          </h6>
          <span
            v-if="props.subtitle"
            class="text-text-secondary"
          >
            {{ props.subtitle }}
          </span>
        </div>
      </div>

      <div class="flex gap-2 items-center">
        <slot name="header-right" />

        <i
          v-if="props.infos"
          aria-controls="dashboard-card-infos-dialog"
          :aria-expanded="isInfosDialogVisible"
          aria-haspopup="dialog"
          :aria-label="props.title"
          class="pi pi-info-circle cursor-pointer text-text-secondary"
          :data-test-id="DATA_TEST_IDS.views.dashboard.card.cardInfosButton"
          role="button"
          tabindex="0"
          @click="isInfosDialogVisible = true"
          @keydown.enter="isInfosDialogVisible = true"
        />
      </div>
    </div>

    <slot />
  </div>

  <BaseDialog
    id="dashboard-card-infos-dialog"
    v-model:visible="isInfosDialogVisible"
    :data-test-id="DATA_TEST_IDS.views.dashboard.card.cardInfosDialog"
    modal
    size="medium"
  >
    <template #header>
      <h4 class="font-semibold">
        {{ props.title }}
      </h4>
    </template>

    <slot name="infos">
      <span class="whitespace-pre-line">
        {{ props.infos }}
      </span>
    </slot>
  </BaseDialog>
</template>
